// hooks/usePreventBackNavigation.js

import { useEffect } from "react";

const usePreventBackNavigation = (
  shouldPreventNavigation: any,
  callback: Function,
) => {
  useEffect(() => {
    const handleBackButton = (event: any) => {
      if (shouldPreventNavigation) {
        event.preventDefault();
        // Execute the callback function if provided
        if (callback && typeof callback === "function") {
          callback();
        }
      }
    };

    if (shouldPreventNavigation) {
      window.history.pushState(null, "", window.location.pathname); // Make sure to push initial state
      window.addEventListener("popstate", handleBackButton);
    }

    if (!shouldPreventNavigation) {
      window.removeEventListener("popstate", handleBackButton);
    }

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [shouldPreventNavigation, callback]);
};

export default usePreventBackNavigation;
